import React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

const contextoCarrito = createContext();

export function useCarrito() {
    return useContext(contextoCarrito);
}

export function ProveedorCarrito({ children }){
    const [carrito, setCarrito] = useState(() => {
        try{
            const raw = localStorage.getItem('carrito');
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem('carrito', JSON.stringify(carrito));
    }, [carrito]);

    //Añadir producto
    const addItem = (producto) => {
        setCarrito((prev) => {
            const existe = prev.find((p) => p._id === producto._id);
            if(existe) return prev;
            return [...prev, { ...producto, cantidad: 1 }];
        });
    };

    //Eliminar producto
    const removeItem = (id) => {
        setCarrito((prev) => prev.filter((p) => p._id !== id));
    };
    const clearCarrito = () => {
        setCarrito([]);
    }

    const cantidadTotal = carrito.reduce((acc, p) => acc + p.Precio, 0);

    return (
        <contextoCarrito.Provider value={{carrito, addItem, removeItem, clearCarrito, cantidadTotal}}>
            {children}
        </contextoCarrito.Provider>
    )
}
